import React from 'react';
import PropTypes from 'prop-types';

import {sendShareRequest} from '~/src/utilities/feed/activity.js';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {BeagleEvents, GtmEvents, InteractionSources} from '~/src/utilities/constants/tracking';
import css from './FacebookShare.module.scss';
import i18nStrings from './FacebookShare.i18n.json';
import ShareFacebook from '~/src/components/svg/action/ShareFacebook';
import {withTypeContext} from '~/src/components/context/TypeContext';
import {TeaserTypes, ContentType, SharePlatformTypes} from '~/src/utilities/constants/types';
import {Asset} from '~/src/utilities/constants/asset';
import {openFacebookShare} from '~/src/utilities/libs/socialMedia';
import {trackGtm} from '~/src/utilities/tracking/gtm';

const getTranslation = initPolyglot(i18nStrings);

class FacebookShare extends React.Component {
    handleClick = () => {
        openFacebookShare(this.props.url);
        const beagleEvent =
            this.props.context.type === TeaserTypes.VIDEOS || this.props.context.type === ContentType.VIDEO
                ? BeagleEvents.VIDEO_SHARE
                : BeagleEvents.STORY_SHARE;
        sendShareRequest(this.props.metadataId, beagleEvent, Asset.STORY, SharePlatformTypes.FACEBOOK);

        trackGtm(GtmEvents.INTERACTION, {
            interactionSource: InteractionSources.SHARE_OVERLAY,
            interactionType: GtmEvents.SHARE_FACEBOOK
        });
    };

    render() {
        return (
            <div className={css.facebookShare} onClick={this.handleClick}>
                <span className={css.shareLogo}>
                    <ShareFacebook title={getTranslation('shareWithFacebook')} />
                </span>
                <div>{getTranslation('shareWithFacebook')}</div>
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    FacebookShare.propTypes = {
        metadataId: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };
}

export default withTypeContext(FacebookShare);
